import store from '@/store'
import { app } from '@/main.js'
import { useToast } from 'vue-toastification'
import router from '@/router'


const toast = useToast()


export default (to, from, next) => {
  let isAdmin = false;

  if (app.helpers.getTokenParam()){
    store.commit('auth/setToken', app.helpers.getTokenParam());
  }

  if (store.state.auth.jwtPayload == null){
    store.dispatch('auth/logout');
    return;
  }

  if (store.state.auth.jwtPayload.organisation_role) {
    for (const product of store.state.auth.jwtPayload.organisation_role[0].products) {
      if (product.product == "cyber_security_online_awareness_training") {
        isAdmin = product.roles.includes("admin");
      }
    }
  }


  if (!store.state.auth.isSuperAdmin && !isAdmin && (store.state.user.organisation != null && !store.state.user.organisation.is_organisation_admin)) {
    toast.error("Only training admins are allowed to view this page.");
    return router.push('/training/assigned-training');
  }


  return next()
}

